import React, { useState } from 'react';
import { Input } from 'antd';

const SearchBox: React.FC<{ onSearch: (query: string) => void }> = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearchQuery(query);
    onSearch(query);
  };

  return (
    <Input.Search
      placeholder="Search..."
      value={searchQuery}
      onChange={handleSearch}
      allowClear // Optionally, add a clear button
    />
  );
};

export default SearchBox;